import { useState } from 'react'
import { supabase } from '../lib/supabase'
import type { SuggestedListItem } from './useSuggestedList'

export function useAcceptSuggestedList(householdId: string | null) {
  const [loading, setLoading] = useState(false)
  const [error,   setError]   = useState<string | null>(null)

  async function accept(items: SuggestedListItem[]): Promise<string | null> {
    if (!householdId || items.length === 0) return null

    setLoading(true)
    setError(null)

    try {
      const { data: list, error: listErr } = await supabase
        .from('shopping_lists')
        .insert({ household_id: householdId, generated_at: new Date().toISOString() })
        .select('id')
        .single()

      if (listErr || !list) throw listErr ?? new Error('Failed to create list')

      const { error: itemsErr } = await supabase
        .from('list_items')
        .insert(
          items.map(i => ({
            list_id:       list.id,
            item_id:       i.itemId,
            status:        'pending',
            urgency_score: 999,
            sort_order:    0,
            is_one_off:    false,
          })),
        )

      if (itemsErr) throw itemsErr

      setLoading(false)
      return list.id
    } catch (err: any) {
      setError(err.message ?? 'Failed to create list')
      setLoading(false)
      return null
    }
  }

  return { accept, loading, error }
}
